import { RADAR_PATH } from '~/routes/paths';

export const createNestedPath = (nestedUrl) => `${RADAR_PATH}${nestedUrl}`;
